/* External */
import cloneDeepL from "lodash/cloneDeep";
import { all } from "redux-saga/effects";
import { addMinutes } from "date-fns";

/* Services */
import { backendService } from "../../../services";

/* Others */
import { ACTION_TYPES_BASE_NAME } from "./actions";
import { PDP_ASSET_TYPES, TIME_ZONE, makeFetchSaga } from "../../../utils";

const getAssetBackendService = ({ assetType }) => {
  let beService;
  switch (assetType) {
    case PDP_ASSET_TYPES.series:
      beService = backendService.content.getShowById;
      break;
    case PDP_ASSET_TYPES.live:
      beService = backendService.content.getSchedules;
      break;
    default:
      beService = backendService.content.getEntity;
  }
  return beService;
};

const getAssetParams = (payload) => {
  let params;
  switch (payload.assetType) {
    case PDP_ASSET_TYPES.live:
      const { stationId, startTime } = payload;
      const startDate = startTime ? new Date(startTime) : new Date();
      params = [
        {
          count: 2,
          fromDatetime: addMinutes(startDate, 1),
          region: TIME_ZONE,
          stationIDs: [stationId]
        }
      ];
      break;
    default:
      const { assetId } = payload;
      params = [assetId];
  }
  return params;
};

const getProcessAssetResponse = (data, payload) => {
  let processedData;
  switch (payload.assetType) {
    case PDP_ASSET_TYPES.series:
      const serie = cloneDeepL(data);

      const sortedSeasons = serie?.seasonsList
        .filter(({ hasPublishedEpisodes }) => hasPublishedEpisodes)
        .sort((seasonA, seasonB) => seasonA.seasonNumber - seasonB.seasonNumber);

      serie.seasonsList = sortedSeasons;
      processedData = serie;
      break;
    case PDP_ASSET_TYPES.live:
      const [
        {
          schedules: [asset]
        }
      ] = data;
      processedData = asset;
      break;
    default:
      processedData = data;
  }
  return processedData;
};

const fetchPdpAssetSaga = makeFetchSaga(
  ACTION_TYPES_BASE_NAME,
  {
    getFunc: getAssetBackendService,
    getParams: getAssetParams
  },
  getProcessAssetResponse
);

export default function* () {
  yield all([fetchPdpAssetSaga]);
}
